/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { FractionDependencies } from './dependenciesFractionClass.generated';
import { createTyped } from '../../factoriesAny.js';
export var typedDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  ComplexDependencies: ComplexDependencies,
  DenseMatrixDependencies: DenseMatrixDependencies,
  FractionDependencies: FractionDependencies,
  createTyped: createTyped
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesTyped.generated.js
// module id = 2
// module chunks = 0